import React from "react";

export function Logo({ className = "h-10", variant = "default" }) {
  return (
    <img
      src="/brand/sambiva-logo.png"
      alt="Sambiva"
      className={className}
      style={variant === "white" ? { filter: "brightness(0) invert(1)" } : undefined}
    />
  );
}
